module.exports = __webpack_public_path__ + "img/blue3.8222a012.jpg";